import { ChangeDetectionStrategy, Component, computed, inject, model } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { TranslocoPipe, TranslocoService } from '@ngneat/transloco';
import { DialogsService } from '../dialogs.service';
import { WorkshiftResource } from '../../modules/admin/workshifts/workshifts.types';
import { WorkshiftsService } from '../../modules/admin/workshifts/workshifts.service';
import { Utils } from '../../core/utils/utils';

@Component({
    selector: 'search-user-event-dialog',
    templateUrl: './search-user-event-dialog.component.html',
    imports: [MatAutocompleteModule, FormsModule, MatButtonModule, MatFormFieldModule, MatIconModule, MatInputModule, ReactiveFormsModule, TranslocoPipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class SearchUserEventDialogComponent {

    search = model<string | WorkshiftResource>('');

    public data: { workshiftDate: string, serviceId: string, workplaceCode: string, usersWithEvents: string[] } = inject(MAT_DIALOG_DATA);
    private dialogRef = inject(MatDialogRef<SearchUserEventDialogComponent>);
    private dialogsService = inject(DialogsService);
    private transloco = inject(TranslocoService);
    private workshiftsService = inject(WorkshiftsService);

    workplaceUsers = toSignal(this.workshiftsService.retrieveWorkshiftResources({
        date: this.data.workshiftDate,
        serviceId: this.data.serviceId,
        workplaceCode: this.data.workplaceCode
    }));

    filteredUsers = computed(() => {
        const users = this.workplaceUsers();
        const search = this.search();
        if (typeof search === 'string') {
            return search.length > 0 ? users.filter(u => Utils.removeAccents(u.userName).toUpperCase().includes(Utils.removeAccents(search).toUpperCase())) : users;
        } else {
            return [];
        }
    });

    displayFn(user: string | WorkshiftResource): string {
        return user  ? typeof user === 'string' ? user : user.userName : '';
    }

    addUserEvent() {
        const user = this.search();
        if (user && typeof user !== 'string') {
            if (this.data.usersWithEvents.includes(user.userId)) {
                this.dialogsService.openErrorDialog({
                    message: this.transloco.translate('services.workshifts.userEventAlreadyExists')
                });
                return;
            }
            this.dialogRef.close(user);
        } else {
            this.dialogsService.openErrorDialog({
                message: this.transloco.translate('services.workshifts.selectAnUserBefore')
            });
        }
    }

    closeDialog(user?: WorkshiftResource) {
        this.dialogRef.close(user);
    }

}
